import { render } from "./_item-title.vue?vue&type=template&id=64c37ec9&lang=pug"
import script from "./_item-title.vue?vue&type=script&lang=js"
export * from "./_item-title.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__